/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Autonachrueckenenabled2Inputs */

const en__field_autonachrueckenenabled2 = /** @type {(inputs: _Field_Autonachrueckenenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`automatic moveup enables`)
};

const de__field_autonachrueckenenabled2 = /** @type {(inputs: _Field_Autonachrueckenenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auto Nachrücken aktiv`)
};

/**
* | output |
* | --- |
* | "automatic moveup enables" |
*
* @param {_Field_Autonachrueckenenabled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_autonachrueckenenabled2 = /** @type {((inputs?: _Field_Autonachrueckenenabled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Autonachrueckenenabled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_autonachrueckenenabled2(inputs)
	return de__field_autonachrueckenenabled2(inputs)
});
export { _field_autonachrueckenenabled2 as "_field_autoNachrueckenEnabled" }